import { NgModule } from '@angular/core';
import { CustomCheckoutEventBuilder } from './custom-checkout-event.builder';

@NgModule({})
export class CustomCheckoutEventModule {
  // tslint:disable-next-line:variable-name
  constructor(_customCheckoutEventBuilder: CustomCheckoutEventBuilder) {}
}
